import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_REIMBURSEMENT,
  DELETE_REIMBURSEMENT,
  UPDATE_REIMBURSEMENT,
  ADD_NEW_REIMBURSEMENT,
} from "./actionType";

import {
  getReimbursementSuccess,
  getReimbursementFail,
  deleteReimbursementSuccess,
  deleteReimbursementFail,
  updateReimbursementSuccess,
  updateReimbursementFail,
  addReimbursementSuccess,
  addReimbursementFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveReimbursementApi,
  getReimbursementApi,
  updateReimbursementApi,
  deleteReimbursementApi,
  addNewReimbursementApi
} from "../../helpers/backend_helper";

function* getReimbursement({ payload: reimbursement }) {
  try {
    const response = yield call(getReimbursementApi, reimbursement);
    yield put(getReimbursementSuccess(GET_REIMBURSEMENT, response.data));
  } catch (error) {
    yield put(getReimbursementFail(GET_REIMBURSEMENT, error));
  }
}

function* onUpdateReimbursement({ payload: reimbursement }) {
  try {
    if (reimbursement.setApprove) {
      const response = yield call(approveReimbursementApi, reimbursement);
      yield put(updateReimbursementSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateReimbursementApi, reimbursement);
      yield put(updateReimbursementSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateReimbursementFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteReimbursement({ payload: reimbursement }) {
  try {
    const response = yield call(deleteReimbursementApi, reimbursement);
    yield put(deleteReimbursementSuccess({ reimbursement, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteReimbursementFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewReimbursement({ payload: reimbursement }) {
  try {
    const response = yield call(addNewReimbursementApi, reimbursement);
    yield put(addReimbursementSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addReimbursementFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetReimbursement() {
  yield takeEvery(GET_REIMBURSEMENT, getReimbursement);
}

export function* watchUpdateReimbursement() {
  yield takeEvery(UPDATE_REIMBURSEMENT, onUpdateReimbursement);
}

export function* watchDeleteReimbursement() {
  yield takeEvery(DELETE_REIMBURSEMENT, onDeleteReimbursement);
}

export function* watchAddNewReimbursement() {
  yield takeEvery(ADD_NEW_REIMBURSEMENT, onAddNewReimbursement);
}

function* reimbursementSaga() {
  yield all([
    fork(watchGetReimbursement),
    fork(watchDeleteReimbursement),
    fork(watchUpdateReimbursement),
    fork(watchAddNewReimbursement)
  ]);
}

export default reimbursementSaga;
